(function () {
  'use strict';

  let STORAGE_KEY = 'theme_rv';
  let MAX_ITEMS = 8;

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {}
  }

  function add(product) {
    if (!product || !product.id) return;
    let items = getAll().filter(function (p) { return p.id !== product.id; });
    items.unshift(product);
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    save(items);
  }

  function renderGrid(containerId, currentProductId, moneyFormat) {
    let container = document.getElementById(containerId);
    if (!container) return;

    let items = getAll().filter(function (p) {
      return String(p.id) !== String(currentProductId);
    });

    if (!items.length) {
      container.closest('.rv-section') && (container.closest('.rv-section').hidden = true);
      return;
    }

    container.closest('.rv-section') && (container.closest('.rv-section').hidden = false);

    let html = items.map(function (product) {
      let price = product.price
        ? formatMoney(product.price, moneyFormat)
        : '';
      let img = product.featured_image
        ? '<img src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" class="rv-card__img" width="400" height="400">'
        : '<div class="rv-card__img rv-card__img--placeholder"></div>';

      return '<a href="' + product.url + '" class="rv-card" data-animate>'
        + '<div class="rv-card__media">' + img + '</div>'
        + '<div class="rv-card__info">'
        + '<p class="rv-card__title">' + escapeHtml(product.title) + '</p>'
        + (price ? '<p class="rv-card__price">' + price + '</p>' : '')
        + '</div>'
        + '</a>';
    }).join('');

    container.innerHTML = html;
  }

  function formatMoney(cents, format) {
    let fmt = format || '${{amount}}';
    return fmt.replace('{{amount}}', (cents / 100).toFixed(2));
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  window.RecentlyViewed = { add: add, getAll: getAll, renderGrid: renderGrid };
})();
